import React, { createContext, useReducer } from "react";

const initialState = {
    loading: true,
    recipients: "",
    inFlight: false,
};

const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_START":
            return { ...state, inFlight: true };

        case "REQUEST_END":
            return { ...state, inFlight: false };
        
        case "FETCH_RECIPIENTS":
            const newState1 = { ...state };
            newState1['recipients'] = action.payload.recipients;
            newState1['loading'] = false;
            return newState1;
        
        case "ADD_RECIPIENT":
            const { newRecipientData } = action.payload;
            const newState2 = { ...state, inFlight: false };
            newState2['recipients'] = [...newState2.recipients, ...[newRecipientData]];
            return newState2;
        
        case "UPDATE_RECIPIENTS":
            const { updatedRecipient } = action.payload;
            const newState3 = { ...state, inFlight: false };
            const updatedRecipientsData = [...newState3.recipients];
            
            for(var i=0; i<updatedRecipientsData.length; i++){
                if((updatedRecipientsData[i].id === updatedRecipient.id)){
                    updatedRecipientsData[i] = updatedRecipient;
                }
            }
            newState3['recipients'] = updatedRecipientsData;
            
            return newState3;
                
        case "DELETE_RECIPIENT":
            const { recipientId } = action.payload;

            const newState4 = { ...state, inFlight: false };
            newState4.recipients = newState4.recipients.filter((recipient) => recipient.id !== recipientId);

            return newState4;

        default:
            return state;
    }
};

const useThunkReducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const enhancedDispatch = React.useCallback(
        (action) => {
            if (typeof action === "function") {
                action(dispatch);
            } else {
                dispatch(action);
            }
        },
        [dispatch]
    );

    return [state, enhancedDispatch];
};

export const PaymentsContext = createContext();

export const PaymentsProvider = ({ children }) => {
    const [state, dispatch] = useThunkReducer(paymentsReducer, initialState);

    return (
        <PaymentsContext.Provider value={{ state, dispatch }}>
            {children}
        </PaymentsContext.Provider>
    );
};
